<template>
    <div
        v-if="editable"
        :class="['bo-cell-toggle', id]"
    >
        <!-- for local search sort-->
        <span style="display: none">{{ toggleStatus }}</span>
        <label
            id="toggle"
            class="switch"
        >
            <input
                :id="id"
                type="checkbox"
                v-model="toggleStatus"
            />
            <span class="slider round"></span>
        </label>
    </div>
    <!-- read only -->
    <div v-else-if="this.value && this.value != '0' && this.value != ''">
        <!-- for local search sort-->
        <span style="display: none">{{ toggleStatus }}</span>
        <i class="icon-check"></i>
    </div>
    <div v-else>
        <span style="display: none">{{ toggleStatus }}</span>
        <span>-</span>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        toggleStatus: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
};
</script>

<style scoped>
[class^="icon-"]::before,
[class*=" icon-"]::before {
    margin: 0 !important;
}
</style>
